<HomeNavBar ref="homeNavBarRef" @active_profile="set_active_home_profile" />
<div class="px-2 h-100 marketplace-shell-wrap">
  <div class="container-fluid mt-2 marketplace-page-shell h-100">
    <div class="mb-3">
       <button
        class="btn rounded-circle p-2 d-flex align-items-center justify-content-center membership-view-back-btn"
        @click="go_back">
        <i class="bi bi-arrow-left fs-4"></i>
      </button>
    </div>

    <div
      v-if="loading"
      class="marketplace-loader-wrap d-flex align-items-center justify-content-center"
      role="status"
      aria-live="polite"
    >
      <div class="marketplace-loader-card">
        <div class="marketplace-loader-orbit">
          <span class="marketplace-loader-ring marketplace-loader-ring-primary"></span>
          <span class="marketplace-loader-ring marketplace-loader-ring-secondary"></span>
          <span class="marketplace-loader-core d-flex align-items-center justify-content-center">
            <i class="bi bi-shop fs-2 text-primary"></i>
          </span>
          <span class="marketplace-loader-dot marketplace-loader-dot-one"></span>
          <span class="marketplace-loader-dot marketplace-loader-dot-two"></span>
        </div>
        <p class="marketplace-loader-title mb-1">Loading shop</p>
        <p class="marketplace-loader-copy mb-0">We are bringing your listings and activity into view.</p>
      </div>
    </div>

    <div v-else>
      <div class="row align-items-center marketplace-header mb-3 g-3">
        <div class="col-12 col-lg-3">
          <div class="d-flex flex-column align-items-start gap-2">
            <h4 class="text-dark mb-1 fw-bold marketplace-toolbar-title">{{ shop_title }}</h4>
            <p class="text-muted small mb-0">Manage your marketplace listings and customer activity.</p>
            <button
              class="btn btn-link text-dark fw-500 p-0 text-decoration-none d-inline-flex align-items-center gap-2 d-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#myShopActionsOffcanvas"
              aria-controls="myShopActionsOffcanvas"
            >
              <i class="bi bi-list fs-4"></i>
              <span>Manage shop</span>
            </button>
          </div>
        </div>

      </div>

      <div
        v-if="is_catalogue_sale_selecting"
        class="d-flex flex-wrap align-items-center gap-2 mb-3"
      >
        <button
          class="btn btn-sm btn-primary text-xxs rounded"
          type="button"
          :disabled="!selected_catalogue_sale_product_ids.length"
          @click="open_catalogue_sale_form_modal"
        >
          Continue sale ({{ selected_catalogue_sale_product_ids.length }})
        </button>
        <button
          class="btn btn-sm btn-light text-xxs rounded border"
          type="button"
          @click="toggle_all_catalogue_sale_products"
        >
          {{ selected_catalogue_sale_product_ids.length === get_sale_eligible_catalogue_products().length ? 'Clear selection' : 'Select all products' }}
        </button>
        <button
          class="btn btn-sm btn-light text-xxs rounded border"
          type="button"
          @click="cancel_catalogue_sale_selection"
        >
          Cancel
        </button>
      </div>

      <div class="row g-3 align-items-start">
        <div class="col-12">
      <div class="scrollable-container marketplace-shop-scroll flex-grow-1 pb-5 mb-5">
      <div class="row g-1 marketplace-products-grid">
        <div
          v-if="!is_catalogue_sale_selecting"
          v-can-create.permission="product_create_permission"
          :class="catalogue_items.length === 0 ? 'col-12 catalogue-add-placeholder-empty' : 'col-6 col-sm-6 col-md-4 col-lg-4 col-xl-2 mb-1'"
        >
          <div
            class="catalogue-add-placeholder-card marketplace-product-card h-100 d-flex flex-column align-items-center justify-content-center text-center p-3 border-2 border-dashed bg-white pointer"
            data-bs-toggle="modal"
            data-bs-target="#addItemModal"
            @click="set_modal_type('product')"
          >
            <div class="catalogue-add-placeholder-icon rounded-circle d-flex align-items-center justify-content-center mb-3">
              <i class="bi bi-plus-lg text-primary fs-4"></i>
            </div>
            <p class="fw-bold text-dark text-xs mb-1">Add Product</p>
            <p class="text-muted text-xxs mb-0">Click to create a product.</p>
          </div>
        </div>

        <div v-if="catalogue_items.length === 0 && is_catalogue_sale_selecting" class="col-12">
          <div class="text-center py-5">
            <i class="bi bi-box-seam display-4 text-muted"></i>
            <h5 class="fw-bold mt-3">No products yet</h5>
            <p class="text-muted mb-0">Your products will appear here once they are created.</p>
          </div>
        </div>

        <div
          v-for="product in catalogue_items"
          :key="product.id"
          class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-2 mb-1"
        >
          <div
            class="marketplace-product-card h-100 d-flex flex-column position-relative"
            :class="[
              is_catalogue_sale_selecting && is_catalogue_sale_product_selected(product) ? 'border-primary border-2' : '',
              is_catalogue_sale_selecting && !is_catalogue_sale_product_eligible(product) ? 'opacity-75' : ''
            ]"
            @click="is_catalogue_sale_selecting ? toggle_catalogue_sale_product(product) : view_product_details(product)"
          >
            <div v-if="is_catalogue_sale_selecting" class="position-absolute top-0 start-0 m-2 z-index-10">
              <input
                class="form-check-input shadow-sm"
                type="checkbox"
                :checked="is_catalogue_sale_product_selected(product)"
                :disabled="!is_catalogue_sale_product_eligible(product)"
                :title="!is_catalogue_sale_product_eligible(product) ? 'Only products can be selected' : 'Select product'"
                @click.stop
                @change="toggle_catalogue_sale_product(product)"
              >
            </div>
            <div class="position-relative marketplace-card-media">
              <div class="ratio ratio-4x3">
                <img
                  :src="product.images.length ? product.images[0].image_url : 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/image_placeholder.webp'"
                  :alt="product.name"
                  class="marketplace-card-image"
                />
              </div>

              <div class="position-absolute top-0 end-0 m-2">
                <div class="d-flex gap-2">
                  <span
                    class="badge"
                    :class="product.is_published ? 'task-chip task-chip-status' : 'task-due-chip d-inline-flex align-items-center fw-500 task-due-chip-overdue'"
                  >
                    {{ product.is_published ? 'Published' : 'Draft' }}
                  </span>
                </div>
              </div>
              <div
                v-if="should_show_product_sale(product)"
                class="position-absolute top-0 start-0 m-2"
                :class="is_catalogue_sale_selecting ? 'ms-5' : ''"
              >
                <span class="badge bg-danger text-white text-xxs rounded-0 px-2 py-1">SALE</span>
              </div>
            </div>

            <div class="card-body p-3 d-flex flex-column text-start marketplace-card-body flex-grow-1">
              <div class="flex-grow-1">
                <p class="marketplace-card-name mb-1">{{ product.name }}</p>
              </div>

              <div class="d-flex justify-content-between align-items-center gap-2 mt-3 marketplace-card-footer">
                <div class="marketplace-card-price-wrap">
                  <div v-if="should_show_product_sale(product)">
                    <div class="marketplace-card-sale-price-block">
                      <span class="marketplace-card-price text-nowrap">R{{ format_price(get_product_sale_price(product)) }}</span>
                      <span class="marketplace-card-sale-meta">
                        <span class="text-muted text-xxs text-decoration-line-through">R{{ format_price(get_product_original_price(product)) }}</span>
                        <span class="text-danger text-xxs">{{ get_product_sale_discount_label(product) }}</span>
                      </span>
                    </div>
                  </div>
                  <span v-else class="marketplace-card-price">R{{ format_price(display_price(product)) }}</span>
                </div>
              </div>

              <div class="mt-3">
                <div class="d-flex flex-wrap gap-1">
                  <button class="btn btn-primary rounded text-xxs py-1 px-2 flex-fill" @click.stop="toggle_publish(product)">
                    {{ product.is_published ? 'Unpublish' : 'Publish' }}
                  </button>
                  <button class="btn btn-secondary rounded text-xxs py-1 px-2 flex-fill" @click.stop="open_manage_modal(product)">
                    Manage
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="offcanvas offcanvas-end home-nav-offcanvas bg-light border-start" tabindex="-1" id="myShopActionsOffcanvas" aria-labelledby="myShopActionsOffcanvasLabel">
  <div class="offcanvas-header home-nav-offcanvas-header bg-white border-bottom px-4 py-3">
    <div>
      <span class="home-nav-offcanvas-kicker d-flex align-items-center gap-1 text-muted text-uppercase fw-bold lh-1">Marketplace</span>
      <h6 class="home-nav-offcanvas-title text-dark fw-bold mb-0 mt-1" id="myShopActionsOffcanvasLabel">Manage shop</h6>
    </div>
    <button type="button" class="btn-close text-reset home-nav-offcanvas-close rounded-circle bg-light opacity-100" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body home-nav-offcanvas-body d-flex flex-column gap-3 p-3">
    <section class="home-nav-menu-section d-flex flex-column gap-1">
      <div class="home-nav-menu-heading d-flex align-items-center justify-content-between px-1 text-muted text-xxs fw-bold text-uppercase lh-1">
        <span>Shop Tools</span>
      </div>
      <button
        v-can-create.permission="'products'"
        class="home-nav-menu-row primary w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#addItemModal"
        data-bs-dismiss="offcanvas"
        @click="set_modal_type('product')"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-plus-lg"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <span class="text-dark fw-500 text-xxs">Add Product</span>
          <small class="text-muted text-xxs fw-500">Create a new listing for your catalogue.</small>
        </span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
      <button
        class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-dismiss="offcanvas"
        @click="view_all_orders"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-receipt"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <span class="text-dark fw-500 text-xxs">View orders</span>
          <small class="text-muted text-xxs fw-500">{{ new_orders_count ? `${new_orders_count} new ${new_orders_count === 1 ? 'order' : 'orders'}` : 'Open the full orders page.' }}</small>
        </span>
        <span class="ms-auto d-inline-flex align-items-center gap-2">
          <span v-if="new_orders_count" class="badge rounded-pill bg-primary text-white text-xxs">{{ new_orders_count }}</span>
          <i class="bi bi-chevron-right home-nav-menu-arrow text-primary"></i>
        </span>
      </button>
      <button
        v-if="catalogue_products.length"
        class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-dismiss="offcanvas"
        @click="open_catalogue_promo_code_manager"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-ticket-perforated"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <span class="text-dark fw-500 text-xxs">Catalogue promo</span>
          <small class="text-muted text-xxs fw-500">Manage promo codes for products.</small>
        </span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
      <button
        v-if="catalogue_products.length"
        class="home-nav-menu-row w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start d-none"
        type="button"
        data-bs-dismiss="offcanvas"
        @click="is_catalogue_sale_selecting ? open_catalogue_sale_form_modal() : start_catalogue_sale_selection()"
        :disabled="is_catalogue_sale_selecting && !selected_catalogue_sale_product_ids.length"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-tags"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <span class="text-dark fw-500 text-xxs">{{ is_catalogue_sale_selecting ? `Continue sale (${selected_catalogue_sale_product_ids.length})` : 'Start sale' }}</span>
          <small class="text-muted text-xxs fw-500">Select catalogue items and discount them.</small>
        </span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
      <button
        v-if="is_catalogue_sale_selecting"
        class="home-nav-menu-row primary w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-dismiss="offcanvas"
        @click="toggle_all_catalogue_sale_products"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-check2-square"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm d-none">
          <span class="text-dark fw-500 text-xxs">{{ selected_catalogue_sale_product_ids.length === get_sale_eligible_catalogue_products().length ? 'Clear selection' : 'Select all products' }}</span>
          <small class="text-muted text-xxs fw-500">Update the current sale selection.</small>
        </span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
      <button
        v-if="is_catalogue_sale_selecting"
        class="home-nav-menu-row primary w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-dismiss="offcanvas"
        @click="cancel_catalogue_sale_selection"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-x-lg"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <span class="text-dark fw-500 text-xxs">Cancel sale setup</span>
          <small class="text-muted text-xxs fw-500">Leave sale selection mode.</small>
        </span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
      <button
        v-if="can_create_business_profile_action"
        class="home-nav-menu-row primary w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-dismiss="offcanvas"
        @click="open_business_profile_from_actions"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-briefcase"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <span class="text-dark fw-500 text-xxs">Create Business Profile</span>
          <small class="text-muted text-xxs fw-500">Set up a business profile for your shop.</small>
        </span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
    </section>
  </div>
</div>

<button
  v-can-create.permission="'products'"
  class="marketplace-owner-fab"
  type="button"
  aria-label="Open manage shop"
  title="Manage shop"
  data-bs-toggle="offcanvas"
  data-bs-target="#myShopActionsOffcanvas"
  aria-controls="myShopActionsOffcanvas"
>
  <i class="bi bi-shop"></i>
  <span class="marketplace-owner-fab-plus">
    <i class="bi bi-plus-lg"></i>
  </span>
</button>

<CatalogueView :vm="view_model"></CatalogueView>

<teleport to="body">
  <div id="productAdvertisementModal" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content rounded-4 border-0 shadow-lg">
        <div class="modal-header border-0">
          <div>
            <h5 class="modal-title">Advertise {{ advertisement_product?.name }}</h5>
            <p class="text-muted text-xxs mb-0">Create and manage this product’s advertisements.</p>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div v-if="product_advertisements.length" class="mb-4">
            <h6 class="text-xxs fw-bold mb-2">Existing advertisements</h6>
            <div class="d-flex flex-column gap-2">
              <div
                v-for="advertisement in product_advertisements"
                :key="advertisement.id"
                class="border rounded p-3 d-flex flex-wrap align-items-center gap-3"
              >
                <img
                  v-if="get_advertisement_image()"
                  :src="get_advertisement_image()"
                  :alt="advertisement.title"
                  class="rounded object-fit-cover"
                  width="64"
                  height="64"
                />
                <div class="flex-grow-1 min-w-0">
                  <div class="fw-500 text-xs">{{ advertisement.title || advertisement_product?.name }}</div>
                  <div class="text-muted text-xxs">
                    {{ advertisement.is_active ? 'Published' : 'Unpublished' }}
                    · {{ advertisement.ad_clicks || 0 }} clicks
                  </div>
                </div>
                <button
                  class="btn btn-light border btn-sm rounded text-xxs"
                  @click="edit_advertisement(advertisement)"
                >
                  Edit
                </button>
                <button
                  v-if="advertisement.is_active || advertisement_product?.is_published"
                  class="btn btn-light border btn-sm rounded text-xxs"
                  @click="toggle_product_advertisement(advertisement)"
                >
                  {{ advertisement.is_active ? 'Unpublish' : 'Publish' }}
                </button>
                <button
                  class="btn btn-danger btn-sm rounded text-xxs"
                  @click="delete_product_advertisement(advertisement)"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>

          <form id="product-advertisement-form" @submit.prevent="save_product_advertisement">
            <div v-if="advertisement_product?.images?.length" class="mb-3">
              <label class="form-label text-xxs fw-500">Advertisement image</label>
              <div class="ratio ratio-16x9 rounded border overflow-hidden">
                <img
                  :src="advertisement_product.images[0].image_url"
                  :alt="advertisement_product.name"
                  class="marketplace-modal-image"
                />
              </div>
              <div class="form-text text-xxs">The product’s first image is used automatically.</div>
            </div>
            <div v-else class="alert alert-light border text-xxs">
              This product has no image. You can still create its advertisement.
            </div>

            <div class="mb-3">
              <label class="form-label text-xxs fw-500">Title</label>
              <input v-model="advertisement_title" class="form-control rounded text-xxs" :placeholder="advertisement_product?.name" />
            </div>
            <div class="mb-3">
              <label class="form-label text-xxs fw-500">Description</label>
              <textarea v-model="advertisement_description" class="form-control rounded text-xxs" rows="3"></textarea>
            </div>
            <div class="mb-3">
              <label class="form-label text-xxs fw-500">Redirect URL</label>
              <input v-model="advertisement_redirect_url" class="form-control rounded text-xxs" placeholder="https://example.com/product" />
            </div>

            <div
              v-if="advertisement_product?.is_published"
              class="d-flex align-items-center justify-content-between border rounded px-3 py-2"
            >
              <span class="text-xxs fw-500">Publish advertisement</span>
              <div class="form-check form-switch mb-0">
                <input v-model="advertisement_is_active" class="form-check-input" type="checkbox" />
              </div>
            </div>
            <div v-else class="alert alert-light border text-xxs mb-0">
              Publish this product before publishing its advertisement.
            </div>
          </form>
        </div>

        <div class="modal-footer border-0">
          <button type="button" class="btn btn-light btn-sm rounded" data-bs-dismiss="modal">Close</button>
          <button
            type="submit"
            form="product-advertisement-form"
            class="btn btn-primary btn-sm rounded"
            :disabled="is_saving_advertisement"
          >
            <span v-if="is_saving_advertisement" class="spinner-border spinner-border-sm me-2"></span>
            {{ is_saving_advertisement ? 'Saving...' : 'Save advertisement' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<ProductPromoCode
  ref="productPromoCodeRef"
  @promo-updated="update_parent_product_promos"
  @promo-deleted="handle_parent_product_promo_deletion"
  @sale-submitted="update_parent_product_sales"
></ProductPromoCode>
